import type { CycleAudienceTypeValue } from '@/constants/cycle-evaluation/CycleEvaluation';
import type { SelectedFilters } from '@/hooks/filters/useCompanyAttributesFilters';
import type { UserFilterParams } from '@/types/api';
import type {
    CompanyAttribute as CompanyAttributeType,
    CompanyManager as CompanyManagerType,
} from '@/types/directory/Company';

import { CycleAudienceType } from '@/constants/cycle-evaluation/CycleEvaluation';

export interface AudienceFilterParamsSelection {
    audienceType: CycleAudienceTypeValue;
    filters: SelectedFilters;
}

export const buildAudienceFilterParams = ({
    audienceType,
    filters,
}: AudienceFilterParamsSelection): UserFilterParams => {
    if (audienceType === CycleAudienceType.ENTIRE_COMPANY) {
        return {};
    }

    const toIds = (items: Array<CompanyAttributeType | CompanyManagerType>) =>
        items.map((item) => item.id).filter((id): id is string => !!id);

    const ifNotEmpty = (items: Array<CompanyAttributeType | CompanyManagerType>) =>
        items.length > 0 ? toIds(items) : undefined;

    return {
        departmentIds: ifNotEmpty(filters.departments),
        jobTitleIds: ifNotEmpty(filters.jobTitles),
        managerIds: ifNotEmpty(filters.managers),
        companyAddressIds: ifNotEmpty(filters.companyAddresses),
        employeeLevelIds: ifNotEmpty(filters.employeeLevels),
        customAttributeIds: ifNotEmpty(filters.customAttributes),
    };
};
